module.exports = __webpack_public_path__ + "img/online_service.41fc4547.png";